import classNames from 'classnames'
import {memo} from 'react'

import type {VcsRootId} from '../../../../types'
import {getVcsRoot} from '../../../packages/Changes/Changes.selectors'

import styles from './ChangeVcsRoots.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  className?: string
  vcsRootId: VcsRootId | null | undefined
  current?: boolean
}

function ChangeVcsRoot({className, vcsRootId, current}: Props) {
  const vcsRoot = useAppSelector(state => getVcsRoot(state, vcsRootId))
  const {name, vcsName} = vcsRoot ?? {}

  if (vcsRoot == null) {
    return null
  }

  return (
    <span
      className={classNames(className, {[styles.currentVcsRoot]: current})}
      title={current ? 'Current vcs root' : ''}
    >{`${name}${vcsName != null ? ` (${vcsName})` : ''}`}</span>
  )
}

export default memo(ChangeVcsRoot)
